import { Typography } from "djuno-design";
import GithubColorIcon from "./../../../assets/icons/socials/github-color.svg?react";
import GitlabColorIcon from "./../../../assets/icons/socials/gitlab-color.svg?react";
import DockerColorIcon from "./../../../assets/icons/socials/docker-color.svg?react";

const GithubDesc = (
  <Typography.Text className="!text-sm">
    You'll need to create a personal access token with the required{" "}
    <Typography.Text className="!inline-block !text-sm" uiType="warning">
      read:packages
    </Typography.Text>{" "}
    permission in{" "}
    <Typography.Link
      target="_blank"
      href="https://github.com/settings/tokens/new?description=&scopes=read%3Apackages"
      className="!text-sm"
    >
      GitHub
    </Typography.Link>{" "}
    <Typography.Text className="!font-semibold !inline-block !text-sm">{`Settings > Developer Settings`}</Typography.Text>
  </Typography.Text>
);

const GitlabDesc = (
  <Typography.Text className="!text-sm">
    You'll need to create a personal access token with the required{" "}
    <Typography.Text className="!text-sm !inline-block" uiType="warning">
      read registry
    </Typography.Text>{" "}
    and{" "}
    <Typography.Text className="!text-sm !inline-block" uiType="warning">
      read API
    </Typography.Text>{" "}
    permissions in{" "}
    <Typography.Link
      target="_blank"
      href="https://gitlab.com/-/user_settings/personal_access_tokens?name=&scopes=read_registry,read_api"
      className="!text-sm"
    >
      GitLab
    </Typography.Link>{" "}
    by navigating to{" "}
    <Typography.Text className="!font-semibold !inline-block !text-sm">{`Edit Profile > Access Tokens`}</Typography.Text>
  </Typography.Text>
);

const DockerDesc = (
  <Typography.Text className="!text-sm !gap-1">
    Enter your Docker Hub username and password. or create an access token with{" "}
    <Typography.Text className="!text-sm !inline-block" uiType="warning">
      read
    </Typography.Text>{" "}
    access permission to use in place of your password by visiting{" "}
    <Typography.Link
      target="_blank"
      href="https://app.docker.com/settings/personal-access-tokens/create"
      className="!text-sm"
    >
      Docker Hub
    </Typography.Link>{" "}
    <Typography.Text className="!font-semibold !inline-block !text-sm">{`Account Settings> Security`}</Typography.Text>
  </Typography.Text>
);

export const getRegisteryData = (typeValue: number) => {
  let data = {
    Title: "Github",
    Icon: <GithubColorIcon className="w-4" />,
    Description: GithubDesc,
  };
  if (typeValue === 1) {
    data = {
      Title: "Gitlab",
      Icon: <GitlabColorIcon className="w-4" />,
      Description: GitlabDesc,
    };
  } else if (typeValue === 2) {
    data = {
      Title: "Docker",
      Icon: <DockerColorIcon className="w-4" />,
      Description: DockerDesc,
    };
  }
  return data;
};
